module.exports = __webpack_public_path__ + "static/media/videoBanner.b77c16e4.png";